import { useState } from "react";
import { useForm } from "react-hook-form";
import { authService } from "@services/authService";
import { ILoginForm } from "../../../types/global";
import { useNavigate } from "react-router-dom";
import LoginUI from "./LoginUI";
const Login = () => {
  const {
    register,
    handleSubmit
  } = useForm<ILoginForm>({
    defaultValues: {
      userNameOrEmailAddress: "",
      password: "",
      rememberClient: true
    }
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(-1);
  const navigate = useNavigate();
  const onSubmit = async (data: ILoginForm) => {
    try {
      setLoading(true);
      await authService.login(data);
      navigate("/inicio");
    } catch (aError: any) {
      if (aError.code === "ERR_NETWORK") {
        setError(0);
      } else {
        setError(1);
      }
    } finally {
      setLoading(false);
    }
  };
  return <LoginUI register={register} loading={loading} error={error} onSubmit={handleSubmit(onSubmit)} />;
};
export default Login;